import { Template } from '../../../../entities/template/entity'

export const getDetailRoute = (template: Template) => {
  return `/dashboard/trials/${template.trialUid}/template/${template.uid}`
}
